import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as a } from "react";
import { I as l } from "../../../../IconBase-CxZyIWw2.js";
const o = a((e, r) => /* @__PURE__ */ s.jsx(
  l,
  {
    ref: r,
    ...e,
    image: (i) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...i,
        children: [
          /* @__PURE__ */ s.jsx(
            "mask",
            {
              id: "mask0_2974_3418",
              width: 8,
              height: 8,
              x: 4,
              y: 4,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: /* @__PURE__ */ s.jsx("circle", { cx: 8, cy: 8, r: 4, fill: "#fff" })
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_3418)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M-.143 0h18.286v16H-.143z" }) })
        ]
      }
    )
  }
));
o.displayName = "AgencyCircleIcon";
export {
  o as AgencyCircleIcon,
  o as default
};
//# sourceMappingURL=index.js.map
